import React from "react"
import PropTypes from "prop-types"
import { BrowserRouter, IndexRoute, MemoryRouter } from "react-router-dom";
import App from "./app";
import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { Provider } from 'react-redux';
import allReducers from './reducers';
import createHistory from 'history/createBrowserHistory';
import {apiMiddleware, isRSAA, RSAA} from 'redux-api-middleware';
import { ConnectedRouter as Router, routerReducer, routerMiddleware, push } from 'react-router-redux'
import {authApiWrapper, apiUnauthorizedWrapper, csrfInit, authInit} from "./utils/auth";
import {library} from '@fortawesome/fontawesome-svg-core'
import {far} from '@fortawesome/pro-regular-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
import {clearNotifications} from "../../admin/app/actions/notifications-actions";
import {questionsWatcher} from "./utils/game-utils";
import createSagaMiddleware from "redux-saga";
import ScrollToTop from './utils/scroll-to-top';

library.add(far);
library.add(fas);
library.add(fab);

// import ReactGA from 'react-ga';
// ReactGA.initialize('UA-114900665-1');

const history = createHistory({});
const historyMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    allReducers,
    applyMiddleware(
        historyMiddleware,
        authApiWrapper,
        apiUnauthorizedWrapper,
        apiMiddleware,
        thunk,
        promise,
        sagaMiddleware
    )
);

authInit(store);

sagaMiddleware.run(questionsWatcher);

history.listen((location, action) => {
    store.dispatch(clearNotifications());
});

class Main extends React.Component {

    render () {
        return (
            <Provider store={store}>
                <Router history={history}>
                    <ScrollToTop>
                        <App/>
                    </ScrollToTop>
                </Router>
            </Provider>
        );
    }
}

Main.propTypes = {};

export default Main;
